//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import * as auth from "@/utils/auth";
export default {
    name: "FileUpload",
    props:{
        /**
         * 图片url路径
         */
        imageUrl:{
          type:String,
          default:""
        },
        /**
         * 文件类型
         */
        filetype:{
          type:String,
          default:"file"
        },
        prop:{
            type:String,
            default:""
        },
        label:{
            type:String,
            default:""
        },
        data:{
          type:null,
          default:""
        },
        fileids:{
          type:Array,
          default: () => []
        },
        formName:{
          type:String,
          default:"record"
        },
        btype:{
            type:String,
            default:""
        },
        keyval:{
            type:String,
            default:""
        },
        tagname:{
            type:String,
            default:""
        },
        tabname:{
            type:String,
            default:""
        },
        docutypeid:{
            type:String,
            default:""
        },
        matchItem:{
          type:String,
          default:""
        },
        editItem:{
          type:String,
          default:""
        },
        rules:{
          type: Array,
          default: () => []
        },
        // 数据对象
        dataObj:{
          type: Object,
          default: () => ({})
        },
        // 数据对象属性名
        dataObjAttr:{
          type: String,
          default: ""
        },
        //文件上传地址
        doUpload:{
          type: String,
          default: 'file/upload'
        },
        //文件获取地址
        getUpload:{
          type: String,
          default: 'file/getfile'
        },
        //文件删除地址
        delUpload:{
          type: String,
          default: 'file/delete'
        },
        //文件下载地址
        downUpload:{
          type: String,
          default: 'file/download'
        },
    },
    data(){
       return {
            fileList: []
      
       }
    },
    methods:{
        beforeAvatarUpload(file) {
            //console.log('2019年09月24日19:49:35 FileUpload.vue[beforeAvatarUpload]——[file] :',file);
            //return true
            if(this.filetype === 'image'){

              let types = ['image/jpeg', 'image/jpg', 'image/png'];
              const isImage = types.includes(file.type);
              let errortip = this.$t('hrcommon.imgtypelimit');

              if (!isImage) {
                errortip = errortip.replace("{0}","\""+'JPG/JPEG/PNG'+"\"")
                this.tipError(errortip);
                return false;
              }
              const isLt1M = file.size / 1024 / 1024 <=10;
              if (!isLt1M) {
                this.tipError("File size up to 10MB only");
                return false;
              }
              this.uploadFile(file)
            }
        },
        // 上传
        async uploadFile(option) {
            //console.log('2019年09月24日19:54:18 FileUpload.vue[触发uploadFile]——[null] :',null);
            let formData = new FormData()
            formData.append('test', 2)
            if(this.filetype === 'image'){
              formData.append('file', option)
              formData.append("isAvatar","1");
            }else{
              formData.append('file', option.file)
              formData.append("isAvatar","0")
            }
            formData.append("btype",this.btype);
            formData.append("keyval",this.keyval);
            formData.append("tagname",this.tagname);
            formData.append("tabname",this.tabname);
            formData.append("docutypeid",this.docutypeid);
            await axios.postUpload(this.doUpload,formData).then((res) => {
                console.log(res);
                if(this.filetype !='image'){
                  this.fileids.push(res.data);
                  this.getupload();
                }else{
                  // let ffToken = auth.getToken();
                  this.$parent.$parent.setfileid(res.data.data.fileid);
                  this.$parent.$parent.getImage(res.data.data.fileid);
                }
                //alert(this.$t("common.savesuccess"));
                //this.tipAlert("",this.$t("common.savesuccess"));

                //未登录的情况下，前端控制保存结果的中英文
                if(res.data.msg=='uploadtip1'){
                  this.tipError(this.$t('hrcommon.uploadtip1'));
                }else if(res.data.msg=='uploadtip3'){
                  this.tipError(this.$t('hrcommon.uploadtip3'));
                }else{
                  this.tipCustomConfirm("default", this.$t("common.savesuccess"), "");
                }
                //option.onSuccess('文件上传成功')
            }).catch((error) => {
                console.log('2019年09月24日17:47:39 FileUpload.vue[上传失败]——[error] :', error)
            })
        },
        handleAvatarSuccess(res, file, fileList) {
//           //获取图片展示在前端
//           if(this.filetype === 'image'){
//             let url = "file/download";
//             let params = {
//               record: {
//                 filename: file.name,
//                 url:file.url,
//                 btype:this.btype,
//                 keyval:this.keyval,
//                 tagname:this.tagname,
//                 tabname:this.tabname
//               }
//             };
//             axios.posttype(url, params,"arraybuffer").then(res => {
//                 return 'data:image/png;base64,' + btoa(
// 　　　　           new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
// 　　             );
//             }).then(data=>{
//                 this.imageUrl = data;
//             });
//           //  this.imageUrl = "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
//           }
//           this.tipAlert('提示',"文件上传成功",'确定')
        },
        clicka(file)
        {
           /* let url = "file/download";
            let params = {
              record: {
                filename: file.name,
                url:file.url
              }
            };
            await axios.post(url, params).then(({data }) => {
                    
            });*/
            let url = this.downUpload;
            let params = {
              record: {
                filename: file.filename,
                url:file.url,
                btype:this.btype,
                keyval:this.keyval,
                tagname:this.tagname,
                tabname:this.tabname,
                docutypeid:this.docutypeid
              }
            };
            axios.posttype(url, params,"arraybuffer").then(res => {
                let blob = new Blob([res.data])
                let url = window.URL.createObjectURL(blob); //表示一个指定的file对象或Blob对象
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = file.filename; //命名下载名称
                a.click(); //点击触发下载  
                window.URL.revokeObjectURL(url);  //下载完成进行释放
            });
        },
        handleChange(file, fileList){
            this.currentdata=fileList

            // this.currentdata.length=0
            // this.currentdata.concat(fileList)
            //console.log('2019年09月26日16:04:42 FileUpload.vue[handleChange]——[this.prop] :',this.prop);
            
            // let fatherObj=this.$parent.$parent.$parent.$parent;
            //this.$parent.$refs[this.formname]
            // if(fileList&&fileList.length===0){
            //     this.currentdata=''
            // }
            //console.log('2019年09月26日16:28:35 FileUpload.vue[handleChange]——[null] :',this.$parent.formName);
            // fatherObj.triggerRule()
            // fatherObj.validateFileUpload()
            // if (fatherObj.$refs[this.formName] == undefined){
            //   // 此时为行项添加附件
            //   fatherObj=this.$parent.$parent.$parent.$parent.$parent;
            // }
            // fatherObj.$refs[this.formName].validateField(this.prop);
        },
        handleRemove(file, fileList){//删除附件
            let url=this.delUpload;
            let params = {
              record: {
                filename: file.filename,
                url:file.url,
                btype:this.btype,
                keyval:this.keyval,
                tagname:this.tagname,
                tabname:this.tabname,
                docutypeid:this.docutypeid
              }
            };
            console.log(params)
            axios.post(url, params).then(data => {
              this.getupload();
              //this.tipAlert("",this.$t("common.delsuccess"));
              this.tipCustomConfirm("default", this.$t("common.delsuccess"), "");
            });
        },
        submitUpload() {
            this.$refs.upload.submit()
        },
        async getupload()
        {
            let url = this.getUpload;
            let params = {
              record: {
                btype: this.btype,
                keyval: this.keyval,
                tagname: this.tagname,
                tabname:this.tabname,
                docutypeid:this.docutypeid
              }
            };
            await axios.post(url, params).then(({ data }) => {
               console.log("列表返回",data);
            if (data.code == "1") {//获取附件列表
                console.log(data);
                  this.fileList=data.data.filelist;
                  this.setUpfilesVal();
                  console.log(this.fileList);
                } else {
                  alert(data.data.msg)
                }
              });
        },
        setUpfilesVal(){
            if(this.dataObj && this.isNotNullOrEmpty(this.dataObjAttr)){
              this.$set(this.dataObj, this.dataObjAttr, this.fileList);
            }
        }
    },
    computed: {
        currentdata:{
            get:function(){
                return this.data;
            },
            set:function(val){
                this.$emit('input',val)
            }
        },
        ifFile:{
          get:function(){
            if(this.filetype === 'file'){
                return true;
            }else{
              return false;
            }
          }
        },
        ifImage:{
          get:function(){
            if(this.filetype === 'image'){
              return true;
            }else{
              return false;
            }
          }
        },
        // ifShowUpBtn:{
        //   get:function(){
        //     if(this.imageUrl !=''){
        //       alert("123");
        //       return false;
        //     }else{
        //       return  true;
        //     }
        //   }
        // }
        readonly: function () {
          console.log("gllthis.keyval"+this.keyval+"ddd");
          if(this.keyval=="")
          {
            return true;
          }
          else{
            if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
              //返回true,设为只读
              return true;
            }else{
              return false;
            }
          }
        },

    },
    watch: {
        // currentfileList(newVal, oldVal) {
        //     // 在监听你使用update事件来更新word,而在父组件不需要调用该函数
        //     this.$emit('update:fileList', this.fileList)
        // }
    },
    mounted() {
        if(this.keyval !=0)
        {
            this.getupload();
         }
    }
}



// WEBPACK FOOTER //
// ./src/pccomponents/FileUpload.vue